export default __webpack_public_path__ + "static/media/dynamic-image.c8c7a596.svg";